/**
 * Returns the parsed contents of the stringified JSON
 */
export default function parseJson(input: string, fallback: Record<string, unknown>) {
    try {
        return JSON.parse(input);
    } catch (e) {
        return fallback;
    }
}
